<div class="loader-container"
     *ngIf="loaderVisible$ | async">
  <div class="loader-content">
    <mat-spinner></mat-spinner>
  </div>
</div>
